//@flow
import Model from '../../Utils/Model/model';

export type MembershipHistoryObject = {
  billing_amount:number,
  created_at:string,
  id:number,
  promo_code:?string,
  status:string,
  updated_at:string,
};

export type PaymentCode = 'amazon'|'stripe';

export type MembershipObject = {
  created_at:string,
  customer_id:string,
  id:string,
  expires_at:?string,
  history:MembershipHistoryObject[],
  next_billing_amount:number,
  next_billing_date:string,
  payment_code:PaymentCode,
  payment_data:{billing_agreement_id?:string, vault_id?:string},
  status:string,
  updated_at:string,
  plan_code:string,
};

export default class MembershipModel extends Model<MembershipObject> {
  getId():string {
    return this.attributes.id;
  }

  getCustomerId():string {
    return this.attributes.customer_id;
  }

  getPaymentCode():?PaymentCode {
    return this.attributes.payment_code;
  }

  getPaymentVaultId():?string {
    const paymentData = this.attributes.payment_data;
    if (!paymentData) return undefined;

    return paymentData['vault_id'];
  }

  getAmazonBillingId():?string {
    const paymentData = this.attributes.payment_data;
    if (!paymentData) return undefined;

    return paymentData['billing_agreement_id'];
  }

  isConnectedToAmazon():boolean {
    const paymentCode = this.attributes.payment_code;
    if (!paymentCode) return false;

    return paymentCode === 'amazon';
  }

  getNextBillingDate():?Date {
    return this._getDate(this.attributes.next_billing_date);
  }

  getNextBillingAmount():number {
    return this.attributes.next_billing_amount;
  }

  getStatus():string {
    return this.attributes.status || '';
  }

  isActive():boolean {
    return this.getStatus() === 'active';
  }

  isCanceled():boolean {
    return this.getStatus() === 'canceled';
  }

  isDeclined():boolean {
    return this.getStatus() === 'declined';
  }

  getExpirationDate():?Date {
    return this._getDate(this.attributes.expires_at);
  }

  getCreatedAtDate():?Date {
    return this._getDate(this.attributes.created_at);
  }

  getUpdatedAtDate():?Date {
    return this._getDate(this.attributes.updated_at);
  }

  isReturningMember():boolean {
    return !!this.getCreatedAtDate();
  }

  getHistory():MembershipHistoryObject[] {
    return this.attributes.history || [];
  }

  getPlanCode():string {
    return this.attributes.plan_code;
  }
}
